import {Injectable} from '@angular/core';
import {Subject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapaCurricularFiltrosService {
  private subject = new Subject<any>();
  _filtros = {
    ambitos: [],
    tags: [],
    areas: new Array(),
    cursos: [],
    descripcion: ''

  };
  _detalles = [''];
  set filtros(value) {
    this._filtros = value;
  }

  get filtros() {
    return this._filtros;
  }

  updateFiltro(filtro: { filtros?: any, detalles?: any[] } = { filtros: this._filtros, detalles: this._detalles }) {
    if (filtro.filtros) {
      this._filtros = filtro.filtros;
      filtro.detalles = this._detalles;
    }
    if (filtro.detalles) {
      this._detalles = filtro.detalles;
      filtro.filtros = this._filtros;
    }
    this.subject.next(filtro);
  }

  emitFiltro() {
      const filtro = {
        'filtros': this._filtros,
        'detalles': this._detalles
      };
      this.subject.next(filtro);
  }

  getFiltrosObservable(): Observable<any> {
    return this.subject.asObservable();
  }
}
